<template>
    <div>
        <div class="row filter-dates">
            <div class="col-6 pr-2">
                <InputDropdown
                    addClass="custom-ddl"
                    v-model="month"
                    :inputLbl="localePage.month"
                    :isFirstSave="true"
                    :isShowErrorLbl="true"
                    :errorInfo="error[0]"
                    :itemList="listMonth"
                    @input="changeFilter()"
                ></InputDropdown>
            </div>
            <div class="linesection"></div>
            <div class="col-6 pl-2">
                <InputDropdown
                    addClass="custom-ddl"
                    v-model="year"
                    :inputLbl="localePage.year"
                    :isFirstSave="true"
                    :isShowErrorLbl="true"
                    :errorInfo="error[0]"
                    :itemList="listYear"
                    @input="changeFilter()"
                ></InputDropdown>
            </div>
        </div>
    </div>
</template>
<script>
import moment from "moment";
// mixins
import LocaleMixin from "@/mixin/LocaleMixin.js";
// helper
import FormHelper from "@/helper/FormHelper.js";

// components
import InputDropdown from "@/components/Input/Dropdown.vue";
export default {
    name: "FilterDate",
    mixins: [LocaleMixin],
    components: {
        InputDropdown,
    },
    data: function () {
        return {
            localePage: {},
            error: [],
            month: null,
            year: null,
            listMonth: [],
            showYear: "",
            txtReturn: null,
        };
    },
    watch: {
        txtReturn: function (newItem) {
            var time = moment(newItem, "YYYY-MM-DD");
            var endDate = time.endOf("month").format("YYYY-MM-DD");
            var noDate = time.format("YYYY-MM");
            var params = {
                startDate: newItem + "T00:00:00",
                endDate: endDate + "T23:59:59",
                noDate: noDate,
            };
            console.log(params);
            this.$emit("afterFilter", params);
        },
    },
    created: function () {
        this.localePage = this.lbl.history;
        this.error = FormHelper.genErrorInfo(1);
        this.listMonth = this.lbl.date.month_full_arr.map((o) => {
            return {
                text: o.strtext + " " + this.showYear,
                value: o.strvalue,
            };
        });
        // get all year
        var now = new Date();
        var year = now.getFullYear();
        var month = now.getMonth() + 1;

        var listYear = [];
        for (let index = 0; index < 3; index++) {
            var y = year - index;
            listYear.push({
                text: (y + 543).toString(),
                value: y.toString(),
            });
        }
        this.listYear = listYear;

        // set current data
        this.year = year.toString();
        this.month = month <= 9 ? "0" + month : month.toString();
    },
    methods: {
        changeFilter: function () {
            this.txtReturn = `${this.year}-${this.month}-01`;
        },
    },
};
</script>
<style lang="scss">
@import "@/style/_mixin.scss";
.filter-dates {
    /* display: flex; */
    margin-right: 35px !important;
    margin-left: 35px !important;
    background-color: $color-light-grey-500;
    border-radius: 25px;
    border: solid 1px $color-text;
    .col-6 {
        max-width: 49% !important;
    }
    .linesection {
        border: 1px solid $color-text;
        height: 25px;
        margin-top: 7.5px;
    }
    .custom-ddl {
        margin-top: 0;
        .ddl-input {
            .btn-ddl-input {
                border: none;
                filter: #4d341c;
                border-radius: 25px;
                color: $color-text !important;
                font-size: 18px !important;
                height: 40px;
                display: flex;
                align-items: center;
                justify-content: flex-start;
                font-weight: normal;
                background-image: url("../../../assets/icon_dropdown.svg");
                background-position-x: calc(100% - 13px);
                background-position-y: 14px;
                background-size: 12px;
                background-color: $color-light-grey-500 !important;
            }
            .dropdown-item {
                color: $color-text;
                font-size: 16px;
            }
        }
    }
}
</style>
